module.exports = __webpack_public_path__ + "down.4e8069e8.png";